/* eslint-disable react/prop-types */
import React from 'react'
import FormRow from '../../../../components/FormRow'
import FormCol from '../../../../components/FormCol'
import Typography from '@material-ui/core/Typography'
import {
  SimpleForm,
  TextInput,
  Toolbar,
  SaveButton,
  useNotify,
  useRefresh,
  Create,
  useUpdate,
  required,
  email,
} from 'react-admin'
import StyledInput from '../../../../components/StyledInput'
import './common'

import UserProvider from '../../../../dataProvider/user'
import { Divider, Grid } from '@mui/material'
import { Chip } from '@material-ui/core'
import RootElement from '../../../../components/RoolElement'
import { FindLandlordDialog } from '../../../../components/FindLandlordDialog'

export const CreateLandlord = (props) => {
  const refresh = useRefresh()
  const notify = useNotify()
  const [update, { loading }] = useUpdate()
  const leadPropertyId = props.record.id

  const onSuccess = (record) => {
    attachLandlordToLead(record.data)
  }

  const onFailure = (error) => {
    notify(`An Error occured creating landlord  ${error}`, 'error', { smart_count: 1 }, true)
    refresh()
  }

  const uniqueEmail = async (value) => {
    const isEmailUnique = await UserProvider.checkEmailIsUnique(value)
    if (!isEmailUnique) {
      return 'Email already used'
    }

    return undefined
  }

  const attachLandlordToLead = (user) => {
    update(
      'leadProperties',
      leadPropertyId,
      { landlord_id: user.id },
      {},
      {
        onSuccess: () => {
          refresh()
          notify('Landlord Created!', 'info', { smart_count: 1 }, true)
        },
        onError: () => {
          notify(`Landlord not attached!`, { type: 'warning' })
        },
      },
    )
  }

  const CustomToolbar = (props) => (
    <Toolbar {...props}>
      <SaveButton onSuccess={onSuccess} onFailure={onFailure} disabled={loading} />
    </Toolbar>
  )

  const handleClickAttach = (record) => {
    if (record) {
      attachLandlordToLead(record)
    }
  }

  return (
    <RootElement>
      <div></div>
      <Divider textAlign="left">
        <Chip color="primary" variant="outlined" label="Contact details" />
      </Divider>
      <div style={{ width: 'auto', margin: '1em' }}>
        <Typography variant="body2">
          {props.record && (
            <Typography variant="body2">
              {props.record.name ? 'Name: ' + props.record.name + '; ' : null}
              {props.record.phone_no ? 'Phone: ' + props.record.phone_no + '; ' : null}
              {props.record.email ? 'Email: ' + props.record.email + '; ' : null}
              {props.record.city ? 'City: ' + props.record.city + '; ' : null}
            </Typography>
          )}
        </Typography>
      </div>
      <Divider textAlign="left">
        <Chip color="primary" label="Create New Landlord" />
      </Divider>
      <Create {...props} record="" resource="users">
        <SimpleForm warnWhenUnsavedChanges toolbar={<CustomToolbar />}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mb={4}>
            <FindLandlordDialog onClickAttach={handleClickAttach} />
          </Grid>
          <FormRow>
            <FormCol xs={12} sm={12} md={8} lg={8}>
              <StyledInput
                component={TextInput}
                source="name.first_name"
                validate={[required()]}
                initialValue=""
                label="First Name"
              />
            </FormCol>
          </FormRow>
          <FormRow>
            <FormCol xs={12} sm={12} md={8} lg={8}>
              <StyledInput
                component={TextInput}
                source="name.last_name"
                validate={[required()]}
                initialValue=""
                label="Last Name"
              />
            </FormCol>
          </FormRow>
          <FormRow>
            <FormCol xs={12} sm={12} md={8} lg={8}>
              <StyledInput
                component={TextInput}
                source="contacts.email"
                validate={[required(), email(), uniqueEmail]}
                initialValue=""
                label="Email"
              />
            </FormCol>
          </FormRow>
          <FormRow>
            <FormCol xs={12} sm={12} md={8} lg={8}>
              <StyledInput
                component={TextInput}
                source="contacts.phone_no"
                validate={[required()]}
                initialValue=""
                label="Phone"
              />
            </FormCol>
          </FormRow>
        </SimpleForm>
      </Create>
    </RootElement>
  )
}
